/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { CRMIntegrationType } from './CRMIntegrationType.js';
import {
    CRMIntegrationTypeFromJSON,
    CRMIntegrationTypeFromJSONTyped,
    CRMIntegrationTypeToJSON,
} from './CRMIntegrationType.js';

/**
 * 
 * @export
 * @interface CrmIntegration
 */
export interface CrmIntegration {
    /**
     * 
     * @type {number}
     * @memberof CrmIntegration
     */
    id?: number;
    /**
     * 
     * @type {CRMIntegrationType}
     * @memberof CrmIntegration
     */
    type?: CRMIntegrationType;
    /**
     * 
     * @type {string}
     * @memberof CrmIntegration
     */
    inboundScript?: string;
    /**
     * 
     * @type {string}
     * @memberof CrmIntegration
     */
    outboundScript?: string;
    /**
     * 
     * @type {any}
     * @memberof CrmIntegration
     */
    options?: any;
    /**
     * 
     * @type {boolean}
     * @memberof CrmIntegration
     */
    isActive?: boolean;
}

/**
 * Check if a given object implements the CrmIntegration interface.
 */
export function instanceOfCrmIntegration(value: object): boolean {
    return true;
}

export function CrmIntegrationFromJSON(json: any): CrmIntegration {
    return CrmIntegrationFromJSONTyped(json, false);
}

export function CrmIntegrationFromJSONTyped(json: any, ignoreDiscriminator: boolean): CrmIntegration {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : CRMIntegrationTypeFromJSON(json['type']),
        'inboundScript': json['inboundScript'] == null ? undefined : json['inboundScript'],
        'outboundScript': json['outboundScript'] == null ? undefined : json['outboundScript'],
        'options': json['options'] == null ? undefined : json['options'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
    };
}

export function CrmIntegrationToJSON(value?: CrmIntegration | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'type': CRMIntegrationTypeToJSON(value['type']),
        'inboundScript': value['inboundScript'],
        'outboundScript': value['outboundScript'],
        'options': value['options'],
        'isActive': value['isActive'],
    };
}

